import { Firebase } from './app'
import 'firebase/firestore'

export default Firebase.firestore();
